import React from "react";

interface FirefoxProps {
  width?: number;
  height?: number;
  className?: string;
}

const Firefox = ({ width = 40, height = 40, className }: FirefoxProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.3125 3.71338C31.3125 4.84545 30.8437 7.3813 31.8594 9.96243C32.875 12.5436 34.4375 11.9851 35.4062 14.6115C36.6875 18.0832 36.0937 22.7473 36.0937 22.7473C36.0937 22.7473 37.6406 27.0643 38.7187 22.4756C41.1094 13.8568 32.3125 5.84168 32.3125 3.71338Z"
        fill="url(#paint0_radial_148_1348)"
      />
      <path
        d="M20.0625 39.502C30.3594 39.502 38.6875 31.4114 38.6875 21.419C38.6875 11.4265 30.3437 3.35107 20.0625 3.35107C9.78125 3.35107 1.45312 11.4416 1.45312 21.419C1.4375 31.4114 9.78125 39.502 20.0625 39.502Z"
        fill="url(#paint1_radial_148_1348)"
      />
      <path
        d="M34.0156 32.5734C33.6094 32.8451 33.1875 33.0866 32.75 33.313C33.3281 32.4828 33.875 31.6376 34.3594 30.7621C34.75 30.3394 35.125 29.9319 35.4219 29.4791C35.5625 29.2526 35.7344 28.996 35.9063 28.6791C36.9531 26.8526 38.1094 23.9093 38.1406 20.8904V20.664C38.1406 19.9093 38.0625 19.1394 37.9063 18.3998C37.9219 18.4602 37.9219 18.5206 37.9375 18.581C37.9219 18.5357 37.9219 18.4904 37.9063 18.4451C37.9219 18.5206 37.9375 18.6111 37.9531 18.6866C38.1719 20.4376 38.0156 22.1432 37.25 23.4111C37.2344 23.4262 37.2188 23.4413 37.2188 23.4715C37.6094 21.5545 37.75 19.4413 37.3125 17.3281C37.3125 17.3281 37.1406 16.3017 35.8281 13.1772C35.0781 11.381 33.7344 9.90171 32.5625 8.83001C31.5313 7.59227 30.5781 6.76208 30.0625 6.23378C28.9844 5.1319 28.5313 4.30171 28.3438 3.77341C28.1875 3.69793 26.1094 1.75076 25.9531 1.67529C25.0469 3.03378 22.2188 7.2602 23.5625 11.1998C24.1719 12.996 25.7188 14.8527 27.3438 15.8942C27.4219 15.9696 28.3125 16.9055 28.7344 19.0187C29.1719 21.2074 28.9375 22.8979 28.0469 25.4187C26.9844 27.6225 24.2656 29.8111 21.7188 30.0376C16.2813 30.5206 14.2813 27.396 14.2813 27.396C16.2188 28.1508 18.375 27.9847 19.6875 27.2149C21 26.43 21.7969 25.8413 22.4531 26.0677C23.0938 26.2942 23.5938 25.63 23.1406 24.9357C22.4219 23.864 21.1094 23.3206 19.8125 23.5319C18.5 23.7432 17.2813 24.7545 15.5625 23.7734C15.4531 23.713 15.3438 23.6376 15.2344 23.5621C15.125 23.4866 15.6094 23.6677 15.4844 23.5923C15.1563 23.4111 14.5469 23.0338 14.4063 22.8979C14.375 22.8677 14.6719 22.9885 14.6406 22.9583C13.0313 21.6753 13.2344 20.7998 13.2813 20.2564C13.3281 19.8187 13.6094 19.2602 14.1094 19.0338C14.3438 19.1545 14.5 19.2602 14.5 19.2602C14.5 19.2602 14.3906 19.064 14.3438 18.9583C14.3594 18.9432 14.375 18.9583 14.4063 18.9432C14.6094 19.0338 15.0313 19.2753 15.2656 19.4111C15.5625 19.6074 15.6563 19.7885 15.6563 19.7885C15.6563 19.7885 15.7344 19.7432 15.6719 19.5772C15.6563 19.5017 15.5625 19.2753 15.2656 19.0489H15.2813C15.4531 19.1394 15.625 19.2602 15.7813 19.381C15.8594 19.0942 16.0156 18.7923 15.9844 18.2489C15.9688 17.8715 15.9688 17.7659 15.9063 17.6149C15.8438 17.4942 15.9375 17.4338 16.0469 17.5696C16.0313 17.464 16 17.3583 15.9531 17.2677V17.2527C16.0938 16.7998 18.8125 15.6074 19.0156 15.4715C19.3438 15.2451 19.6094 14.9583 19.8125 14.6262C19.9688 14.3998 20.0781 14.0677 20.1094 13.5696C20.125 13.2074 19.9531 12.9659 17.1875 12.6942C16.4375 12.6187 15.9844 12.0904 15.7344 11.6074C15.6875 11.5017 15.6406 11.4111 15.5938 11.3055C15.5469 11.1998 15.5156 11.0791 15.4844 10.9583C15.9375 9.70548 16.6875 8.64888 17.8125 7.84888C17.875 7.7885 17.5625 7.86397 17.625 7.80359C17.7031 7.74322 18.1563 7.56208 18.25 7.5168C18.3594 7.47152 17.7969 7.23001 17.2969 7.29039C16.7969 7.35076 16.6875 7.41114 16.4063 7.5168C16.5156 7.41114 16.875 7.2602 16.7969 7.27529C16.25 7.35076 15.5781 7.66775 15 8.01491C15 7.95454 15.0156 7.89416 15.0313 7.83378C14.7656 7.93944 14.0938 8.39227 13.9063 8.76963C13.9219 8.69416 13.9219 8.61869 13.9219 8.54322C13.7188 8.70925 13.5313 8.89039 13.375 9.10171L13.2813 9.1319C11.7188 8.52812 10.3281 8.48284 9.17188 8.75454C8.92188 8.51303 8.79688 8.69416 8.20313 7.45643C8.15625 7.38095 8.23438 7.5319 8.20313 7.45643C8.10938 7.21492 8.26563 7.77341 8.20313 7.45643C7.23438 8.21114 5.95313 9.05643 5.32813 9.6451C5.32813 9.67529 6.04688 9.44888 5.32813 9.6451C5.07813 9.72058 5.09375 9.85642 5.0625 11.1696C5.04688 11.2753 5.0625 11.381 5.04688 11.4715C4.54688 12.0753 4.21875 12.5885 4.09375 12.8602C3.45313 13.9168 2.75 15.5772 2.07813 18.1885C2.375 17.4791 2.73438 16.7998 3.15625 16.1508C2.59375 17.5394 2.04688 19.7281 1.9375 23.0791C2.07813 22.3847 2.25 21.7055 2.46875 21.0262C2.32813 23.8187 2.82813 26.596 3.92188 29.1772C4.3125 30.0979 4.95313 31.5017 6.0625 33.0413C9.53125 36.5583 14.4063 38.747 19.8125 38.747C25.4531 38.747 30.5313 36.3621 34.0156 32.5734Z"
        fill="url(#paint2_linear_148_1348)"
      />
      <path
        d="M29.8281 35.1244C36.6562 34.3546 39.6875 27.5622 35.7969 27.4263C32.2969 27.3206 26.5937 35.4867 29.8281 35.1244Z"
        fill="url(#paint3_radial_148_1348)"
      />
      <path
        d="M36.2969 26.0376C41 23.3961 39.7656 17.6904 39.7656 17.6904C39.7656 17.6904 37.9531 19.7282 36.7188 22.9734C35.5156 26.1885 33.4688 27.6376 36.2969 26.0376Z"
        fill="url(#paint4_radial_148_1348)"
      />
      <path
        d="M21.375 38.5054C27.9375 40.5281 33.5625 35.5318 30.0938 33.8715C26.9375 32.3771 18.2656 37.5545 21.375 38.5054Z"
        fill="url(#paint5_radial_148_1348)"
      />
      <path
        d="M36.7969 28.4681C36.9531 28.2568 37.1719 27.5625 37.3594 27.2455C38.5156 25.4342 38.5312 24.0002 38.5312 23.97C39.2344 20.604 39.1719 19.2153 38.7344 16.6794C38.3906 14.6266 36.875 11.6832 35.5625 10.2794C34.2188 8.81528 35.1562 9.2983 33.8594 8.2266C32.7188 7.00396 31.5937 5.78132 31 5.2983C26.625 1.76623 26.7188 1.01151 26.8125 0.890754L26.75 0.951131C26.7031 0.754905 26.6562 0.588867 26.6562 0.588867C26.6562 0.588867 24.25 2.88321 23.75 6.73226C23.4219 9.23792 24.3906 11.8643 25.8125 13.5398C26.5469 14.4153 27.375 15.2002 28.2812 15.8945C29.3438 17.3738 29.9375 19.2002 29.9375 21.1625C29.9375 26.0832 25.8125 30.053 20.7188 30.053C20.0312 30.053 19.3281 29.9775 18.6562 29.8266C16.25 29.3889 14.875 28.2115 14.1719 27.4115C13.7812 26.9587 13.6094 26.6266 13.6094 26.6266C15.7656 27.3662 18.1406 27.2153 19.5938 26.4455C21.0469 25.6606 21.9375 25.087 22.6562 25.3134C23.3594 25.5398 23.9219 24.8757 23.4219 24.1964C22.9219 23.5172 21.6406 22.536 19.7344 22.8077C18.2812 23.0191 16.9375 24.0153 15.0312 23.0492C14.9062 22.9889 14.7812 22.9134 14.6719 22.853C14.5469 22.7775 15.0781 22.9587 14.9531 22.8832C14.5781 22.7021 13.9219 22.3247 13.75 22.1889C13.7188 22.1587 14.0312 22.2794 14.0156 22.2492C12.2344 20.9813 12.4531 20.1209 12.5 19.5775C12.5469 19.1398 12.875 18.5964 13.4219 18.37C13.6875 18.4908 13.8438 18.5964 13.8438 18.5964C13.8438 18.5964 13.7344 18.4002 13.6719 18.2945C13.6875 18.2794 13.7188 18.2945 13.7344 18.2794C13.9531 18.37 14.4375 18.5964 14.6875 18.7474C15.0156 18.9436 15.125 19.1247 15.125 19.1247C15.125 19.1247 15.2188 19.0794 15.1406 18.9134C15.1094 18.8379 15.0156 18.6115 14.6875 18.3851H14.7031C14.8906 18.4757 15.0781 18.5964 15.25 18.7172C15.3438 18.4304 15.5 18.1285 15.4688 17.5851C15.4531 17.2077 15.4531 17.1021 15.375 16.9662C15.3125 16.8455 15.4062 16.7851 15.5312 16.9209C15.5156 16.8153 15.4688 16.7247 15.4219 16.6191V16.604C15.5781 16.1511 18.5938 14.9738 18.8125 14.8379C19.1719 14.6266 19.4688 14.3398 19.7031 14.0077C19.875 13.7813 20 13.4492 20.0312 12.9511C20.0469 12.7247 19.9688 12.5587 19.1719 12.3775C18.6875 12.2719 17.9531 12.1813 16.7969 12.0757C15.9688 12.0002 15.4688 11.487 15.1875 11.004C15.1406 10.8983 15.0781 10.8077 15.0312 10.7172C14.9844 10.6115 14.9375 10.4908 14.9062 10.3851C15.4063 9.11717 16.3125 8.04547 17.4844 7.30585C17.5469 7.24547 17.2188 7.32094 17.2812 7.26056C17.3594 7.20019 17.875 7.01906 17.9688 6.97377C18.0938 6.92849 17.4688 6.70207 16.9062 6.74736C16.3438 6.80773 16.2344 6.85302 15.9219 6.97377C16.0469 6.86811 16.4375 6.73226 16.3438 6.73226C15.7812 6.79264 15.0312 7.09453 14.3906 7.4417C14.3906 7.38132 14.4063 7.32094 14.4219 7.26056C14.125 7.36623 13.3906 7.81906 13.1719 8.19641C13.1875 8.12094 13.1875 8.04547 13.1875 7.98509C12.9688 8.15113 12.75 8.33226 12.5781 8.54358L12.5625 8.55868C10.8281 7.95491 9.29688 7.90962 8.01562 8.18132C7.73438 7.93981 7.28125 7.56245 6.64062 6.33981C6.59375 6.26434 6.57813 6.49075 6.54688 6.41528C6.29688 5.85679 6.14062 4.93604 6.17188 4.30207C6.17188 4.30207 5.65625 4.52849 5.23438 5.47943C5.15625 5.64547 5.10938 5.75113 5.04688 5.8417C5.01562 5.87189 5.09375 5.52472 5.09375 5.5549C5.01562 5.67566 4.82812 5.8417 4.75 6.06811C4.6875 6.23415 4.60938 6.32472 4.5625 6.52094L4.54688 6.53604C4.54688 6.47566 4.5625 6.29453 4.54688 6.32472C4.34375 6.71717 4.17188 7.12472 4.03125 7.53226C3.79687 8.25679 3.53125 9.25302 3.48437 10.5511C3.46875 10.6417 3.48438 10.7625 3.46875 10.853C2.92188 11.4568 2.54687 11.97 2.40625 12.2266C1.70312 13.2832 0.921875 14.9134 0.171875 17.5096C0.5 16.8002 0.90625 16.1209 1.375 15.487C0.75 16.8606 0.140625 19.0342 0.015625 22.3549C0.171875 21.6606 0.359375 20.9813 0.59375 20.3172C0.484375 22.536 0.75 25.2983 2.20312 28.4077C3.0625 30.2342 5.04688 33.9474 9.90625 36.8455C9.90625 36.8455 11.5625 38.0379 14.3906 38.9285C14.5938 39.004 14.8125 39.0794 15.0312 39.1398C14.9688 39.1096 14.8906 39.0794 14.8281 39.0643C16.7188 39.6077 18.6719 39.8945 20.6562 39.8945C28 39.8945 30.1719 37.0417 30.1719 37.0417L30.1562 37.0568C30.2656 36.9662 30.3594 36.8606 30.4531 36.77C29.2969 37.8266 26.6406 37.9021 25.6562 37.8266C27.3437 37.3436 28.4531 36.936 30.6094 36.1511C30.8594 36.0606 31.125 35.9549 31.3906 35.8342L31.4687 35.7889C31.5156 35.7587 31.5781 35.7436 31.625 35.7134C32.6719 35.2304 33.6719 34.6417 34.5781 33.9323C36.75 32.2568 37.2188 30.6266 37.4688 29.5549C37.4375 29.6606 37.3281 29.9021 37.25 30.053C36.6875 31.2002 35.4531 31.9247 34.1094 32.5285C34.75 31.7134 35.3438 30.8681 35.8906 29.9926C36.3281 29.57 36.4531 28.9059 36.7969 28.4681Z"
        fill="url(#paint6_radial_148_1348)"
      />
      <path
        d="M34.1562 32.4679C35.0469 31.5321 35.8281 30.4453 36.4375 29.2226C37.9844 26.083 40.375 20.8453 38.5 15.3962C37.0156 11.0792 34.9687 8.72453 32.375 6.41509C28.1562 2.6717 26.9844 0.996226 26.9844 0C26.9844 0 22.1094 5.23774 24.2188 10.717C26.3281 16.1962 30.6562 15.9849 33.5156 21.6906C36.8906 28.4075 30.7969 35.7434 25.75 37.7962C26.0625 37.7358 36.9531 35.3509 37.5312 29.3283C37.5 29.434 37.25 31.1094 34.1562 32.4679Z"
        fill="url(#paint7_radial_148_1348)"
      />
      <path
        d="M20.0312 12.9508C20.0469 12.5885 19.8594 12.3621 16.8125 12.0753C15.5625 11.9696 15.0781 10.8526 14.9375 10.3696C14.5 11.4866 14.3125 12.664 14.4063 14.0828C14.4688 15.0187 15.125 16.0149 15.4219 16.5885C15.4219 16.5885 15.4844 16.4979 15.5156 16.4677C16.0938 15.8791 18.5312 14.9885 18.7656 14.8677C19.0312 14.7168 20 14.0376 20.0312 12.9508Z"
        fill="url(#paint8_linear_148_1348)"
      />
      <path
        d="M6.64062 6.33949C6.59375 6.26402 6.57812 6.49044 6.54687 6.41497C6.29687 5.85647 6.14062 4.95081 6.1875 4.30176C6.1875 4.30176 5.67187 4.52817 5.25 5.47912C5.17187 5.64515 5.125 5.75081 5.0625 5.84138C5.03125 5.87157 5.10937 5.5244 5.10937 5.55459C5.03125 5.67534 4.84375 5.84138 4.76562 6.0527C4.70312 6.21874 4.625 6.3244 4.57812 6.53572C4.5625 6.5961 4.59375 6.27912 4.57812 6.3244C3.57812 8.181 3.39062 10.9886 3.5 10.8678C5.625 8.67912 8.04687 8.16591 8.04687 8.16591C7.75 7.98478 7.1875 7.44138 6.64062 6.33949Z"
        fill="url(#paint9_linear_148_1348)"
      />
      <path
        d="M14.6719 29.1924C11.75 27.9849 8.42187 26.2792 8.54687 22.4151C8.71875 17.3283 13.4687 18.3245 13.4687 18.3245C13.2969 18.3698 12.8125 18.7019 12.6406 19.049C12.4687 19.4868 12.1406 20.483 13.125 21.5245C14.6875 23.1547 9.92187 25.3887 17.2656 29.6151C17.4531 29.7057 15.5469 29.5547 14.6719 29.1924Z"
        fill="url(#paint10_linear_148_1348)"
      />
      <path
        d="M13.6406 26.6568C15.7188 27.3512 18.125 27.2304 19.5781 26.4606C20.5469 25.9323 21.7969 25.1021 22.5469 25.3134C21.8906 25.0568 21.3906 24.9361 20.7813 24.921C20.6719 24.921 20.5625 24.921 20.4531 24.9059C20.2344 24.9059 20.0156 24.921 19.7969 24.9361C19.4219 24.9663 19.0156 25.1927 18.6406 25.1625C18.625 25.1625 19 25.0116 18.9688 25.0116C18.7656 25.0568 18.5469 25.0568 18.3281 25.087C18.1875 25.1021 18.0625 25.1172 17.9063 25.1323C13.5781 25.4795 9.9375 22.8682 9.9375 22.8682C9.625 23.8644 11.3281 25.8719 13.6406 26.6568Z"
        fill="url(#paint11_linear_148_1348)"
      />
      <path
        d="M34.1406 32.4983C38.5156 28.3474 40.7188 23.3209 39.7813 17.6606C39.7813 17.6606 40.1562 20.5587 38.7344 23.5172C39.4219 20.6191 39.5 17.0266 37.6875 13.2983C35.2812 8.33226 31.3125 5.70585 29.7969 4.61906C27.5 2.95868 26.5469 1.28321 26.5313 0.936035C25.8438 2.29453 23.7656 6.94358 26.3125 10.9436C28.6875 14.7021 32.4375 15.804 35.0469 19.2455C39.8906 25.6002 34.1406 32.4983 34.1406 32.4983Z"
        fill="url(#paint12_linear_148_1348)"
      />
      <path
        d="M33.5156 21.7059C31.9844 18.6568 30.0781 17.3285 28.2813 15.8945C28.4844 16.1813 28.5469 16.2719 28.6563 16.4681C30.25 18.0983 32.5781 22.0832 30.8906 27.0945C27.6875 36.5134 14.9063 32.0757 13.5625 30.8379C14.1094 36.287 23.5469 38.8983 29.7031 35.3662C33.1875 32.136 36.0156 26.7021 33.5156 21.7059Z"
        fill="url(#paint13_linear_148_1348)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.2565 12.3222) rotate(2.18361) scale(14.3882 20.4893)">
          <stop offset="0.1" stopColor="#FFEA00" />
          <stop offset="0.17" stopColor="#FFDE00" />
          <stop offset="0.28" stopColor="#FFBF00" />
          <stop offset="0.43" stopColor="#FF8E00" />
          <stop offset="0.77" stopColor="#FF272D" />
          <stop offset="0.87" stopColor="#E0255A" />
          <stop offset="0.95" stopColor="#CC2477" />
          <stop offset="1" stopColor="#C42482" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.1889 6.17006) scale(40.8341 39.4473)">
          <stop stopColor="#00CCDA" />
          <stop offset="0.22" stopColor="#0083FF" />
          <stop offset="0.26" stopColor="#007AF9" />
          <stop offset="0.33" stopColor="#005FE7" />
          <stop offset="0.44" stopColor="#2639AD" />
          <stop offset="0.52" stopColor="#401E84" />
          <stop offset="0.57" stopColor="#4A1475" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_148_1348"
          x1="22.6942"
          y1="29.5524"
          x2="15.1553"
          y2="4.02456"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#000F43" stopOpacity="0.4" />
          <stop offset="0.48" stopColor="#001962" stopOpacity="0.17" />
          <stop offset="1" stopColor="#002079" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.5165 26.5383) rotate(5.4278) scale(13.7226 13.265)">
          <stop stopColor="#FFEA00" />
          <stop offset="0.5" stopColor="#FF272D" />
          <stop offset="1" stopColor="#C42482" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(40.5688 13.7667) rotate(5.4278) scale(22.9154 22.1513)">
          <stop stopColor="#FFE900" />
          <stop offset="0.16" stopColor="#FFAF0E" />
          <stop offset="0.32" stopColor="#FF7A1B" />
          <stop offset="0.47" stopColor="#FF4E26" />
          <stop offset="0.62" stopColor="#FF2C2E" />
          <stop offset="0.76" stopColor="#FF1434" />
          <stop offset="0.89" stopColor="#FF0538" />
          <stop offset="1" stopColor="#FF0039" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(41.7157 34.502) rotate(5.4278) scale(21.0273 20.3262)">
          <stop stopColor="#FF272D" />
          <stop offset="0.5" stopColor="#C42482" />
          <stop offset="0.99" stopColor="#620700" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.0074 15.9709) scale(32.8182 31.7036)">
          <stop offset="0.16" stopColor="#FFEA00" />
          <stop offset="0.23" stopColor="#FFDE00" />
          <stop offset="0.37" stopColor="#FFBF00" />
          <stop offset="0.54" stopColor="#FF8E00" />
          <stop offset="0.76" stopColor="#FF272D" />
          <stop offset="0.8" stopColor="#F92433" />
          <stop offset="0.84" stopColor="#E91C45" />
          <stop offset="0.89" stopColor="#CF0E62" />
          <stop offset="0.94" stopColor="#B5007F" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_148_1348"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.1257 1.26761) scale(37.4029 36.1326)">
          <stop offset="0.28" stopColor="#FFEA00" />
          <stop offset="0.4" stopColor="#FFDD00" />
          <stop offset="0.63" stopColor="#FFBA00" />
          <stop offset="0.86" stopColor="#FF9100" />
          <stop offset="0.93" stopColor="#FF6711" />
          <stop offset="0.99" stopColor="#FF4A1D" />
        </radialGradient>
        <linearGradient
          id="paint8_linear_148_1348"
          x1="6.2337"
          y1="14.7989"
          x2="22.3176"
          y2="12.2564"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C42482" stopOpacity="0.5" />
          <stop offset="0.47" stopColor="#FF272D" stopOpacity="0.5" />
          <stop offset="0.49" stopColor="#FF2C2C" stopOpacity="0.51" />
          <stop offset="0.68" stopColor="#FF7A1A" stopOpacity="0.72" />
          <stop offset="0.83" stopColor="#FFB20D" stopOpacity="0.87" />
          <stop offset="0.94" stopColor="#FFD605" stopOpacity="0.96" />
          <stop offset="1" stopColor="#FFE302" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_148_1348"
          x1="6.11237"
          y1="10.7178"
          x2="4.53711"
          y2="4.85677"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#891551" stopOpacity="0.6" />
          <stop offset="1" stopColor="#C42482" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_148_1348"
          x1="9.17908"
          y1="18.9143"
          x2="12.4833"
          y2="23.6926"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.01" stopColor="#891551" stopOpacity="0.5" />
          <stop offset="0.48" stopColor="#FF272D" stopOpacity="0.5" />
          <stop offset="1" stopColor="#FF272D" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_148_1348"
          x1="15.9227"
          y1="27.045"
          x2="16.2184"
          y2="24.0425"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#C42482" />
          <stop offset="0.08" stopColor="#C42482" stopOpacity="0.81" />
          <stop offset="0.21" stopColor="#C42482" stopOpacity="0.57" />
          <stop offset="0.33" stopColor="#C42482" stopOpacity="0.36" />
          <stop offset="0.45" stopColor="#C42482" stopOpacity="0.2" />
          <stop offset="0.56" stopColor="#C42482" stopOpacity="0.09" />
          <stop offset="0.67" stopColor="#C42482" stopOpacity="0.02" />
          <stop offset="0.77" stopColor="#C42482" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_148_1348"
          x1="26.0298"
          y1="1.46645"
          x2="38.1326"
          y2="29.4811"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFF14F" />
          <stop offset="0.27" stopColor="#FFEE4C" />
          <stop offset="0.45" stopColor="#FFE643" />
          <stop offset="0.61" stopColor="#FFD834" />
          <stop offset="0.76" stopColor="#FFC41E" />
          <stop offset="0.89" stopColor="#FFAB02" />
          <stop offset="0.9" stopColor="#FFA900" />
          <stop offset="0.95" stopColor="#FFA000" />
          <stop offset="1" stopColor="#FF9100" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_148_1348"
          x1="28.5763"
          y1="17.4"
          x2="22.8608"
          y2="33.2859"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF8E00" />
          <stop offset="0.04" stopColor="#FF8E00" stopOpacity="0.86" />
          <stop offset="0.08" stopColor="#FF8E00" stopOpacity="0.73" />
          <stop offset="0.13" stopColor="#FF8E00" stopOpacity="0.63" />
          <stop offset="0.18" stopColor="#FF8E00" stopOpacity="0.56" />
          <stop offset="0.23" stopColor="#FF8E00" stopOpacity="0.51" />
          <stop offset="0.28" stopColor="#FF8E00" stopOpacity="0.5" />
          <stop offset="0.39" stopColor="#FF8E00" stopOpacity="0.48" />
          <stop offset="0.52" stopColor="#FF8E00" stopOpacity="0.42" />
          <stop offset="0.68" stopColor="#FF8E00" stopOpacity="0.31" />
          <stop offset="0.84" stopColor="#FF8E00" stopOpacity="0.17" />
          <stop offset="1" stopColor="#FF8E00" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Firefox;
